<template>
  <div class="with-side-panel">
    <div class="content-i">
      <div class="content-box">
        <div class="element-wrapper">
          <div class="d-flex justify-content-between">
            <h6 class="element-header">
              Externe Coachabrechnung
            </h6>
          </div>

          <div class="element-box overflow-hidden">
            <div class="custom_responsive_element">
              <router-link
                  :to="{ name: 'coachBillingPrivateCoachingPreviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                Einzelcoaching
              </router-link>
            </div>

            <div class="custom_responsive_element">
              <router-link
                  :to="{ name: 'coachBillingGroupCoachingPreviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                Gruppen-maßnahmen
              </router-link>
            </div>

            <div class="custom_responsive_element">
              <router-link
                  :to="{ name: 'coachBillingAssistedLivingCoachingPreviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                Betreutes Wohnen
              </router-link>
            </div>

            <div class="custom_responsive_element">
              <router-link
                  :to="{ name: 'coachBillingCaseManagementCoachingPreviewList' }"
                  class="btn btn-primary btn-block"
                  style="padding: 10px">
                DRV Fallmanagement
              </router-link>
            </div>

          </div>
        </div>
      </div>
      <Sidebar></Sidebar>
    </div>
  </div>
</template>

<script setup>
import Sidebar from '@/components/FormSidebar.vue';
</script>

<style scoped>

</style>